// extracted by mini-css-extract-plugin
export default {"passForm":"pass-form_passForm__4Zbhc","buttonBar":"pass-form_buttonBar__ai6KU","formContent":"pass-form_formContent__GyCD7"};